import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Swords, Map, Crosshair, BrainCircuit, Activity } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function WhatsInsideSection() {
  const modules = [{
    icon: <Activity className="w-6 h-6 text-cyan-400" data-id="element-156" />,
    title: 'Wave Management',
    desc: 'Freeze, slow push, fast push y bounce explicados al detalle.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-purple-400" data-id="element-157" />,
    title: 'Guías de Campeones',
    desc: 'Fortalezas, debilidades y condiciones de victoria por pick.'
  }, {
    icon: <Swords className="w-6 h-6 text-red-400" data-id="element-158" />,
    title: 'Lógica de Matchups',
    desc: 'Cómo jugar líneas favorables y cómo sobrevivir a las difíciles.'
  }, {
    icon: <Users className="w-6 h-6 text-green-400" data-id="element-159" />,
    title: 'Sinergias con Supports',
    desc: 'Cómo adaptarte a tu support, incluso si juega mal.'
  }, {
    icon: <Map className="w-6 h-6 text-amber-400" data-id="element-160" />,
    title: 'Mid & Late Game',
    desc: 'Rotaciones, control de objetivos y dónde estar en el mapa.'
  }, {
    icon: <Crosshair className="w-6 h-6 text-orange-400" data-id="element-161" />,
    title: 'Teamfight & Posicionamiento',
    desc: 'Reglas de oro para hacer daño sin morir instantáneamente.'
  }, {
    icon: <BrainCircuit className="w-6 h-6 text-pink-400" data-id="element-162" />,
    title: 'Mentalidad y Consistencia',
    desc: 'Cómo evitar el tilt y mantener un rendimiento alto.'
  }];
  return <section className="py-20 bg-[#0d1117] border-t border-gray-800" data-id="element-163">
      <div className="max-w-6xl mx-auto px-4" data-id="element-164">
        <div className="text-center mb-16" data-id="element-165">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-166">
            ¿Qué vas a encontrar <span className="text-blue-500" data-id="element-167">adentro</span>?
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-168">
            Todo lo que necesitás para masterizar el rol en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-169">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-[#161b22]/80 backdrop-blur-sm p-6 rounded-xl border border-gray-700/50 hover:border-blue-500/30 hover:shadow-[0_0_20px_rgba(59,130,246,0.1)] transition-all duration-300" data-id="element-170">
              <div className="flex items-start gap-4" data-id="element-171">
                <div className="p-3 bg-gray-800 rounded-lg flex-shrink-0" data-id="element-172">
                  {module.icon}
                </div>
                <div data-id="element-173">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-174">
                    {module.title}
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-175">{module.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-176">
          <CtaButton text="📖 QUIERO ESTE LIBRO AHORA" className="w-full md:w-auto" href="#comprar" data-id="element-177" />
        </div>
      </div>
    </section>;
}